import React from 'react';
import './App.css';
import WaitlistForm from './components/WaitlistForm';  // Join Waitlist page
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';  // React Router components
import AboutNova from './components/AboutNova';  // About page
import Navbar from './components/Navbar';
import ReferralRedirect from './components/ReferralRedirect';  // Import ReferralRedirect component
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <Navbar /> {/* Add the Navbar here */}
        {/* Routes to switch between pages */}
        <Routes>
          <Route path="/" element={<WaitlistForm />} />
          <Route path="/about" element={<AboutNova />} />
          <Route path="/refer" element={<ReferralRedirect />} />  {/* Referral route */}
        </Routes>
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
